import React, { useState } from "react";
import { FaFilter, FaInfoCircle } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import Footer from "../../components/footer";
import FooterButton from "../../components/footerButton";
import PickDate from "../../components/common/datePicker";
import WarningModal from "../../components/clearWarningModal";

const AssessmentNotes = (props) => {
  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100 noScroll">
        <div className="card border-0 h-100">
          <div className="card-body mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="font-weight-lighter mb-0">
                HCP: VIEW Assessment Notes
              </h5>
              <div className="">
                <button
                  className="btn btn-outline-primary rounded py-1 h-35 w-116"
                  data-toggle="modal"
                  data-target="#filterModal"
                >
                  <FaFilter size={16} />
                  <small className="ml-2">Filter</small>
                </button>
              </div>
            </div>
            <hr />
            <div className="noScroll h-90"></div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AssessmentNotes;
